
export default {
    init() {
    },
    finalize() {

        let searchQuery = null;
        const searchForm = document.querySelector('#searchForm');
        const searchSuggestions = document.querySelectorAll('.suggested-search');

        //Adding search function to each suggested search term.
        searchSuggestions.forEach(function(suggestion) {

            const searchTerm = suggestion.dataset.searchTerm;

            suggestion.addEventListener('click', function(e) {

                searchQuery = searchTerm;
                let queryURL = '/wp-json/search/v1/get/?q=' + searchQuery;

                makeSearchRequest(queryURL);
            });
        })

        searchForm.addEventListener('submit', function(e) {
            e.preventDefault();
            getQuery();
        });

        if (document.querySelector('#searchQuery').value != '') {
            getQuery();
        }


        //Updates ajax query url with terms from search form.
        function getQuery() {
            searchQuery = document.querySelector('#searchQuery').value;
            let queryURL = '/wp-json/search/v1/get/?q=' + searchQuery;

            makeSearchRequest(queryURL);
        }


        //Ajax function to perform search.
        function makeSearchRequest(queryURL) {
            // Send the Ajax request.
            $.ajax({
                url: queryURL,
                method: 'GET',
                data: {
                q: searchQuery,
                },
            }).done(function(e) {

                //Output search results
                if (Array.isArray(e)) {

                    //Update search results label
                    let resultsText = e.length + ' results for `' + searchQuery + '`';
                    const resultsHeader = document.querySelector('.results-header')
                    resultsHeader.innerHTML = resultsText;

                    //Hides recommended search terms.
                    const popularSearchesContainer = document.querySelector('.popular-searches');
                    $(popularSearchesContainer).hide();

                    //Reveal results container.
                    const resultsContainer = document.querySelector('.search-results-container');
                    $(resultsContainer).show().removeClass('hide');

                    //clear current results and suggested searches.
                    resultsContainer.innerHTML = '';

                    //Populate results container with each search result.
                    e.forEach(function(item) {

                        let resultCard = document.createElement('div');
                        let resultHtml = `
                            <a href="${item.permalink}" class="search-item-container">
                                <div class="search-item-inner">
                                    <h5 class="title">${item.title} <span class="icon-arrow-right"></span></h5>
                                    <p class="description">${item.description}</p>
                                </div>
                            </a>
                            `;
                            
                        resultCard.innerHTML = resultHtml;
                        resultsContainer.append(resultCard);
                    });
                }
            });
        }
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateSearch.js